import { api_url } from "@/config/api_url";
import { defineStore } from "pinia";
import { useNotificationStore } from "./notificationStore";
import axios from "axios";

export const useSearchMissionStore = defineStore('searchMissionStore', {
	state: () => ({
		vehicles: [],
		missions: [],
	}),
	actions : {
		async getAllMissions(){
            const token = localStorage.getItem('token');
            if (token) {
                axios.defaults.headers.common['Authorization'] = token;
            }
            const response = await axios.get(`${api_url}/getAllMissions`);
            if(response.status==200){
				this.missions = response.data.missions
            }else{
                useNotificationStore().setNotification("Error", response.statusText, "mdi-alert", "red");
            }
        },

        async getAllVehicles(){
            const token = localStorage.getItem('token');
            if (token) {
                axios.defaults.headers.common['Authorization'] = token;
            }
            const response = await axios.get(`${api_url}/getAllVehicles`);
            if(response.status==200){
				this.vehicles = response.data.data
            }else{
                useNotificationStore().setNotification("Error", response.statusText, "mdi-alert", "red");
            }
        },

        async getMissionsByVehicle(vehicle_id){
            const token = localStorage.getItem('token');
            if (token) {
                axios.defaults.headers.common['Authorization'] = token;
            }
            const response = await axios.get(`${api_url}/getMissionsByVehicle/${vehicle_id}`);
            if(response.status==200){
				this.missions = response.data.missions
            }else{
                useNotificationStore().setNotification("Error", response.statusText, "mdi-alert", "red");
            }
        },
        

        handleError(error) {
            useNotificationStore().setNotification('Error', error.response.data, 'mdi-alert', 'error');
        },

	}
});